import React from "react";
import styled from "styled-components";
import File from "./elements/File";

const StyledTemplate = styled.div`
  color: ${({ theme }) => theme.colors.darkgrey};
  margin-top: 20px;
  font: normal normal normal 16px Open Sans;
`;

const StyledBody = styled.div`
  color: ${({ theme }) => theme.colors.darkgrey};
  margin-top: 12px;
  opacity: 0.7;
  font: normal normal normal 16px Open Sans;
`;

export default function Note({ fileSelected, fileName, headers, onClick }) {
  return (
    <>
      <StyledTemplate>Template File Name</StyledTemplate>
      {!fileSelected ? (
        <StyledBody>
          Please select the correct module and Country first
        </StyledBody>
      ) : (
        <>
          <File fileName={fileName} handleClick={onClick} />
          <StyledBody>
            NOTE - Template file headers are
            {headers.map((header, i) => {
              if (i + 1 === headers.length)
                return <b key={i}>{`'${header}' `}</b>;
              return <b key={i}>{`'${header}', `}</b>;
            })}
          </StyledBody>
        </>
      )}
    </>
  );
}
